function resizeWindow() {}

function fetchEventFilter({ blockEvents, tag, year, month, day }){
	fetch( `${site_url}ajax/functions.php?operation=eventsWithFilterDate&tag=${tag}&year=${year}&month=${month}&day=${day}`)
	.then((response) => response.json())
	.then((data) => {
		blockEvents.innerHTML = data.html;
		navigationEventsFilter( blockEvents );
	})
}

function getValuesFilterEvents(stateFilter, shortcode){
	stateFilter.year = shortcode.querySelector('#year').value;
	stateFilter.month = shortcode.querySelector('#month').value;
	stateFilter.day = shortcode.querySelector('#day').value;

	fetchEventFilter( stateFilter );
}

function navigationEventsFilter( blockEvents ){
	if( !blockEvents.querySelector('.pagination') ){
		return false;
	}

	let eachItems 		= blockEvents.querySelectorAll('.filterEvents_item'),
		eachNumberPag 	= blockEvents.querySelectorAll('.pagination ul li'),
		prevPag 		= blockEvents.querySelector('.js-prevArrow'),
		nextPag			= blockEvents.querySelector('.js-nexArrow'),
		numberActive	= eachNumberPag[0];

	eachNumberPag.forEach( number => {
		number.addEventListener( 'click', () => {
			eachNumberPag.forEach( number => { number.classList.remove('active') });

			setTimeout(() => {
				blockEvents.scrollIntoView({ 
					behavior: "smooth", 
					block: "center"
				});
			}, 500);

			if( !number.previousElementSibling ){
				prevPag.classList.add('disabled');
			}else{
				prevPag.classList.remove('disabled');
			}
			if( !number.nextElementSibling ){
				nextPag.classList.add('disabled')
			}else{
				nextPag.classList.remove('disabled')
			}

			eachItems.forEach( item => {
				if( item.dataset.nav == number.dataset.nav ){
					item.classList.remove('hidden');
				}else{
					item.classList.add('hidden');
				}
			} );

			number.classList.add('active');
		} );
	} );

	prevPag.addEventListener( 'click', () => {
		if( numberActive.previousElementSibling ){
			let prevItem = numberActive.previousElementSibling;
			if( !prevItem.previousElementSibling ){
				prevPag.classList.add('disabled')
			}
			prevItem.click();
			numberActive = prevItem;
			nextPag.classList.remove('disabled')
		}
	} );

	nextPag.addEventListener( 'click', () => {
		if( numberActive.nextElementSibling ){
			let nextItem = numberActive.nextElementSibling;
			if( !nextItem.nextElementSibling ){
				nextPag.classList.add('disabled')
			}
			nextItem.click();
			numberActive = nextItem;
			prevPag.classList.remove('disabled')
		}
	} );

}

function eventsWithFilter(){
	let eachShortcode = document.querySelectorAll(`.js-filterEvents`);
	eachShortcode.forEach( shortcode => {
		if (shortcode.querySelector(".js-single-events")) {
			let singleEvents = shortcode.querySelector(".js-single-events");

			const dayOptions = {
				month: 'short',
				day: 'numeric'
			};

			let currentDay = new Date(`${singleEvents.dataset.date} 00:00:00`),
			minDay = singleEvents.dataset.min ? new Date(`${singleEvents.dataset.min} 00:00:00`) : null,
			maxDay = singleEvents.dataset.max ? new Date(`${singleEvents.dataset.max} 00:00:00`) : null;

			let arrows = singleEvents.getElementsByTagName("button");
			arrows[0].addEventListener("click", () => setNewDate(-1));
			arrows[1].addEventListener("click", () => setNewDate(1));

			if (minDay && minDay.getTime() === currentDay.getTime()) {
				arrows[0].classList.add('hidden');
			}

			let dayName = currentDay.toLocaleString('default', dayOptions);

			let stateFilter = {
				blockEvents: shortcode.querySelector('.filterEvents_inner'),
				tag: shortcode.dataset.tag,
				year: currentDay.getFullYear(),
				month: currentDay.getMonth(),
				day: currentDay.getDate()
			};

			fetchEventFilter(stateFilter);

			function setNewDate(operation) {
				currentDay = new Date(currentDay.getFullYear(), currentDay.getMonth(), currentDay.getDate() + operation);

				arrows[0].classList.toggle('hidden', minDay && minDay.getTime() === currentDay.getTime());
				arrows[1].classList.toggle('hidden', maxDay && maxDay.getTime() === currentDay.getTime());

				dayName = currentDay.toLocaleString('default', dayOptions);
				singleEvents.getElementsByTagName("span")[0].textContent = dayName;

				stateFilter.year = currentDay.getFullYear();
				stateFilter.month = currentDay.getMonth();
				stateFilter.day = currentDay.getDate();

				fetchEventFilter(stateFilter);
			}

		} else {
			let stateFilter = {
					blockEvents: shortcode.querySelector('.filterEvents_inner'),
					tag: shortcode.dataset.tag,
					year: shortcode.querySelector('#year').value,
					month: shortcode.querySelector('#month').value,
					day: shortcode.querySelector('#day').value
				};
	
			shortcode.querySelectorAll('select').forEach( select => {
				select.addEventListener( 'change', () => {
					getValuesFilterEvents(stateFilter, shortcode);
				} );
			} );
	
			getValuesFilterEvents(stateFilter, shortcode);
		}
	} );
}


function scrollDown() {}
$(document).ready(function() {
    $("#home").length > 0 && ($(".white-bar-sp").addClass("open"), $(".pop-up-parad").delay(6e3).animate({
        right: "-663px"
    }, 500), setTimeout(function() {
        $(".white-bar-sp").removeClass("open")
    }, 6e3)), $(".white-bar-sp").click(function(e) {
        return e.preventDefault(), $(this).hasClass("open") ? $(".pop-up-parad").stop().animate({
            right: "-663px"
        }, 500) : $(".pop-up-parad").stop().animate({
            right: "0px"
        }, 500), $(this).toggleClass("open"), !1
    }), $(window).resize(function(e) {
        resizeWindow()
    }), resizeWindow(), $(".badges").slick({
        accessibility: true
    }), setTimeout(function() {
        $(".badges").slick("setPosition")
    }, 1e3), $(window).scroll(function(e) {
        scrollDown();
        var n = $(document).scrollTop();
        n > 20 ? ($("#header").addClass("scroll", 250), $("#header .firstLogo").addClass("logo-type")) : ($("#header").removeClass("scroll", 250), $("#header .firstLogo").removeClass("logo-type"))
    }), $("#email-signup a#emailSignup").click(function() {
        var e = $("input[name=first_name_signup]"),
            n = $("input[name=last_name_signup]"),
            i = $("#email-signup input[name=email_address_signup]"),
            a = $("#email-signup input[name=lang]"),
            t = "firstname=" + e.val() + "&lastname=" + n.val() + "&email_address=" + i.val() + "&list_id=" + list_id + "&language=" + a.val();
        return $.ajax({
            url: FRONTEND_ROOT + "ajax/email-signup.php",
            type: "GET",
            data: t,
            cache: !1,
            success: function(e) {
                1 == e ? (IS_LIVE && ga("send", "event", "form", "click", "specials"), "es" == a ? $("#email-signup #email-error").html("<p>Gracias por suscribirse.</p>") : $("#email-signup #email-error").html("<p>Thank you for your interest.</p>"), $("#email-signup #email-error").fadeIn("slow"), $("#email-signup input").fadeOut("slow"), $("#email-signup a#emailSignup").fadeOut("slow")) : ($("#email-signup #email-error").html(e), $("#email-signup #email-error").fadeIn("slow"))
            }
        }), !1
    }), $(".dining-nav li a").click(function(e) {
        var n = $(this).attr("href");
        return $("body, html").animate({
            scrollTop: $(n).offset().top - $("#header-menus").height()
        }, 800, "easeOutExpo"), !1
    }), $(window).scroll(function(e) {
        scrollDown();
        var n = $(document).scrollTop();
        n > 0 ? $("#header-menus").addClass("scroll") : $("#header-menus").removeClass("scroll")
    }), $(".arrow-home").click(function(e) {
        $("body, html").animate({
            scrollTop: $(window).height() - $("header").outerHeight()
        }, 800, "easeOutExpo")
    }), $("#content .content li").wrapInner("<span></span>"), $(".main-content-home li").wrapInner("<span></span>"), $(".sym-slides").slick({
        accessibility: !1
    }), $(".offer").click(function() {
        $(this).children(".checkbox").hasClass("active") ? ($(this).children(".checkbox").removeClass("active"), $("input[name=promo]").val("")) : ($(".offer .checkbox").removeClass("active"), $(this).children(".checkbox").addClass("active"), $("input[name=rateplanid]").val($(this).attr("attr-value")))
    }), $(".speedrfp_button").on("click", function() {
        $("#speedrfp_button_text").trigger("click")
    }), $(".book-show").click(function() {
        $(".book-back").fadeIn()
    }), $(".close-btn").click(function() {
        $(".book-back").fadeOut()
    }), $(".each-special:first-of-type").addClass("active"), $(".each-special").click(function() {
        $(".each-special").removeClass("active"), $(this).addClass("active")
    }), 

    $(".rfpNow").on("click", function() {
        ga("send", "event", "RFP Form", "click", "Wedding RFP");
        console.log('tracking')
        
     }), 
    
    $(".book-now").on("click", function() {
        ga("send", "event", "reservations", "click", "book now")
        
    }), 
    
    $(".bookNow").on("click", function() {
         ga("send", "event", "header widget", "click", "book now");
        
    }), 

    $('#primary-nav .submenu').each(function(){
        $(this).parent().addClass('has-submenu');
        $(this)
          .siblings("a")
          .after(
            '<a href="#" class="expand-menu" aria-label="expand submenu"><span class="hidden">Expand</span></a>'
          );
    });
    $(".expand-menu").click(function(e){
        e.preventDefault();
        $(this).next().slideToggle();
    });
    $(".menu-toggle, .close-menu").click(function(e){
        e.preventDefault();
        $(".nav-section").toggleClass("opened");
    });
    
    $("#clickme").click(function() {
        $("#box-w-g").toggle("slow", function() {})
    }), $("#CheckIn").datepicker({
        changeMonth: 0,
        numberOfMonths: 1,
        minDate: 0,
        onSelect: function(e) {
            let getDate;
            let newDate;
            getDate = $(this).datepicker("getDate"), 
            newDate = new Date(getDate.getTime()), 
            newDate.setDate(newDate.getDate() + 1), 
            $("#CheckOut").datepicker("setDate", newDate), 
            $("#CheckOut").datepicker("option", "minDate", e)
        }
    }),
    
    
    $("#btn1").click(function(){
	     $(".cont").toggleClass("open-it")
	     $(this).text(($(this).text() == 'Show More') ? 'Show Less' : 'Show More');
	    
	     
    });
    
    if( document.querySelector(`.js-filterEvents`) ){
		eventsWithFilter();
	}
    
    
    $("#CheckOut").datepicker({
        changeMonth: 0,
        numberOfMonths: 1,
        onSelect: function(e) {
            $("#CheckIn").datepicker("option", "maxDate", e)
        }
    })
});
var fancyboxModule = function(e, n) {
    var indexVid;
    return indexVid = function() {
        var n, i = e(".vidOpener"),
            a = i.siblings(".videoTag").html();
        i.length && i.fancybox({
            content: a,
            padding: 0,
            width: "80%",
            height: "80%",
            beforeShow: function() {
                n = e(".fancybox-inner").find("video").get(0), n.load(), n.play()
            }
        })
    }, {
        init: function() {
            indexVid()
        }
    }
}(jQuery);
$(function() {
    fancyboxModule.init()
});

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
    const badgeContainer = document.querySelector('#badge-container');
    const badgesList = badgeContainer.querySelector('.badges');
    const slickPrev =  badgesList.querySelector('.slick-prev');
    const slickNext = badgesList.querySelector('.slick-next');

    if (slickPrev && slickNext && badgesList) {
        badgeContainer.insertBefore(slickPrev, badgesList);
        badgeContainer.appendChild(slickNext);
    }
}, 500);
});

